// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1pMGo","footer":"ModalCreateQualiphyProcedure_footer__3tvXq","additionData":"ModalCreateQualiphyProcedure_additionData__3QQj7"};